import i18n from '@/i18n'
import { organizationService } from '@/helpers/services/organization.service'
import { filtersHelper, sharedHelper } from '@/utils'
import {
  LISTING_STATE,
  listingMutations,
  listAction,
  detailAction,
  writeAction,
  createdMsg,
} from '@/state/listing.store'

export const ORGANIZATION_MODULE = 'organization'

export const GET_ALL_ORGANIZATION = 'getAllOrganization'
export const GET_ORGANIZATION = 'getOrganization'
export const CREATE_ORGANIZATION = 'createOrganization'
export const UPDATE_ORGANIZATION_STATUS = 'updateOrganizationStatus'

export const state = LISTING_STATE()

/**
 * `tenant_id` is the id, and it is a NUMBER — it is the join key shared with
 * ai_bot and the widget script on the customer's site, not a local uuid.
 */
function mapOrganizationRow(item) {
  return {
    id: item.tenant_id,
    tenantId: item.tenant_id,
    name: item.name,
    isActive: item.is_active,
    agentCount: item.agent_count,
    conversationCount: item.conversation_count,
    /*
     * When the mirror was last confirmed against ai_bot. Surfaced rather than
     * hidden: a name that looks wrong is almost always a mirror that has not
     * run, and the screen can say so instead of inviting somebody to "fix" it
     * here — where there is no rename, because ai_bot owns the name.
     */
    syncedAt: filtersHelper.getDateFormat(item.synced_at),
    isSynced: !sharedHelper.isNullOrEmpty(item.synced_at),
    /*
     * ai_bot's live view. Four answers, kept apart on purpose — flattening
     * any two of them is a sentence the screen gets wrong, and an unreachable
     * bot reading as a neutral dash is the one that matters:
     *
     *   botAsked false      with_bot was off; say nothing
     *   botAvailable false  asked, ai_bot unreachable
     *   bot null            asked and answered, but the bot has no such brand
     *                       — a mirror row with nothing behind it
     *   bot object          asked and answered
     */
    botAsked: Object.prototype.hasOwnProperty.call(item, 'bot'),
    botAvailable: item.bot_available !== false,
    bot: item.bot,
    botSkills: item.bot && item.bot.skills_enabled ? item.bot.skills_enabled : [],
  }
}

export const actions = {
  [GET_ALL_ORGANIZATION]: listAction((filter) => organizationService.getAllOrganizations(filter)),

  [GET_ORGANIZATION]: detailAction(({ id }) => organizationService.getOrganization(id)),

  [CREATE_ORGANIZATION]: writeAction(
    ({ data }) => organizationService.createOrganization(data),
    createdMsg('module.organization'),
    GET_ALL_ORGANIZATION
  ),

  [UPDATE_ORGANIZATION_STATUS]: writeAction(
    ({ id, isActive }) => organizationService.updateOrganizationStatus(id, isActive),
    () => i18n.t('label.updateX', [i18n.t('label.status')]),
    GET_ALL_ORGANIZATION
  ),

}

export const mutations = listingMutations(mapOrganizationRow)
